import React from 'react';

import { navigate } from '@reach/router';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

interface ITabMenu {
  eventId?: string;
  clubId: string;
  selected: number;
  sections: any;
}

export const TabMenu = (props: ITabMenu) => {
  const { clubId, eventId, selected, sections } = props;

  const setTab = (_: any, newValue: number) =>
    navigate(
      eventId
        ? `/event/${eventId}/${sections[newValue] === 'event-info' ? '' : sections[newValue]}`
        : `/club/${clubId}/${sections[newValue] === 'home' ? '' : sections[newValue]}`
    );

  return (
    <Tabs
      value={selected}
      onChange={setTab}
      indicatorColor="primary"
      textColor="primary"
      className="nav-bar"
      centered={true}
    >
      {Object.keys(sections)
        .filter(i => isNaN(Number(i)))
        .map((label, index) => (
          <Tab
            label={label.replace('-', ' ')}
            key={`tab-${index}`}
            className="nav-tab"
            classes={{
              selected: 'selected',
              wrapper: 'nav-tab-label'
            }}
          />
        ))}
    </Tabs>
  );
};
